








































































import { PropType } from 'vue';

import { IQuoteTermTemplate, QuoteTermTemplate } from '@/models';

import Draggable from 'vuedraggable';
import { compareOrder, getObjectValueByPath } from '@/utils/helpers';
import Proxyable from '@/mixins/proxyable';
import mixins from '@/utils/mixins';

export default mixins(Proxyable).extend({
  props: {
    value: {
      type: Array as PropType<IQuoteTermTemplate[]>,
      default: () => []
    }
  },

  components: { Draggable },

  data() {
    return {
      headers: [
        {
          text: '',
          align: 'start',
          width: 30,
          sortable: false,
          value: 'note'
        },
        {
          text: '#',
          align: 'center',
          width: 50,
          sortable: false,
          value: 'index'
        },
        {
          text: 'Title',
          align: 'start',
          sortable: false,
          value: 'title'
        },
        {
          sortable: false,
          align: 'end',
          value: 'actions'
        },
        {
          text: '',
          align: 'center',
          width: 20,
          sortable: false,
          value: 'drag'
        }
      ]
    };
  },

  computed: {
    internalValue: {
      get(): IQuoteTermTemplate[] {
        return this.internalLazyValue;
      },
      set(val: IQuoteTermTemplate[]) {
        if (val === this.internalLazyValue) return;

        this.internalLazyValue = val;

        // hack for passing multiple function on the emit values
        this.$emit('input', val);
        this.$emit('change', val);
      }
    }
  },

  watch: {
    value: {
      handler(terms: IQuoteTermTemplate[]) {
        this.internalLazyValue = terms;
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    getObjectValueByPath,

    goToQuoteTermTemplate(item: IQuoteTermTemplate, createForm = true) {
      this.$emit('click:term', item, createForm);
    },

    updateTermListOrder() {
      const termsClone: IQuoteTermTemplate[] = [...this.internalValue];

      const terms = termsClone.map(
        (term: IQuoteTermTemplate, index: number) => {
          return new QuoteTermTemplate({
            ...term,
            order: index + 1
          });
        }
      );

      const difference = terms.filter(compareOrder(termsClone));

      this.$emit('update:order', difference);
    }
  }
});
